import React, { useEffect, useState } from "react";
import "./CustomCursor.css";

export default function CustomCursor() {
  const [dotPos, setDotPos] = useState({ x: 0, y: 0 });
  const [circlePos, setCirclePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const move = (e) => {
      setDotPos({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  // Smooth trailing effect
  useEffect(() => {
    const delay = setInterval(() => {
      setCirclePos((prev) => ({
        x: prev.x + (dotPos.x - prev.x) * 0.50, // smooth motion
        y: prev.y + (dotPos.y - prev.y) * 0.50,
      }));
    }, 10);

    return () => clearInterval(delay);
  }, [dotPos]);

  return (
    <>
      {/* Outer circle follows slowly */}
      <div
        className="cursor-circle"
        style={{ left: circlePos.x, top: circlePos.y }}
      ></div>

        {/* Dot follows exactly */}
      <div
        className="cursor-dot"
        style={{ left: dotPos.x, top: dotPos.y }}
      ></div>
    </>
  );
}
